<template>
  <Dialog v-model:visible="showModal" class="w-11/12 bg-white shadow rounded-xl" :modal="true" style="position:relative">
    <loading :active="!showSelectPostDialogMyside"
            :can-cancel="true"
            :on-cancel="onCancel"
            :is-full-page="false"
            :color="'#fff'"
            :background-color="'#000'"
            :opacity="'0.8'"
            :loader=" dots">
    </loading>
    <template #header>
      <div class="flex flex-col space-y-3">
        <div class="w-full text-gray-900 font-semibold">
          {{lang['components']['Dialog']['SelectPostDialog']['dialog_title']}}
          <button
            class="text-sm border border-blue-700 text-blue-700 hover:bg-blue-700 hover:text-white rounded-md px-4 py-1 ml-4"
            @click="posts_data_update()">
            <i class="pi pi-refresh"></i>{{lang['components']['Dialog']['SelectPostDialog']['update_button']}}
          </button>
        </div>
        <div v-if="false" class="w-full text-gray-900 font-semibold">
          <Dropdown v-model="postType" :options="postTypeList" optionLabel="name" optionValue="code" :placeholder="lang['components']['Dialog']['SelectPostDialog']['tab_placeholder']" class="w-full rounded-md" />
        </div>
      </div>
    </template>
    <div class="card">
      <TabView ref="tabview1" @tab-click="onTabClick($event)">
        <TabPanel :header="lang['components']['Dialog']['SelectPostDialog']['TabPanel_post']">
          <div class="flex flex-wrap justify-between space-1-2 px-6">
            <Dropdown v-model="type" :options="types" optionLabel="name" optionValue="code" :placeholder="lang['components']['Dialog']['SelectPostDialog']['post']['types_placeholder']" class="w-1/4 rounded-md" />
            <div class=" bg-white rounded-md flex items-center w-3/5 p-2 shadow-sm border border-gray-200">
              <i class="pi pi-search"></i>
              <input v-model="searchKey" type="search" class="w-full pl-4 text-sm outline-none focus:outline-none bg-transparent">
            </div>
            <button class="text-white px-4 whitespace-no-wrap rounded-xl transition duration-300 bg-blue-900 ml-4" @click="searchMaterial()">{{lang['components']['Dialog']['SelectPostDialog']['post']['searchMaterial']}}</button>
          </div>
          <div
            class="align-middle inline-block min-w-full shadow overflow-hidden bg-white shadow-dashboard px-6 pt-3 rounded-bl-lg rounded-br-lg">
            <!-- <DataTable :value="dataTableList" :paginator="true" class="p-datatable-customers" :rows="10"
                  dataKey="id" :rowHover="true" v-model:selection="selectedCustomers" paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown" :rowsPerPageOptions="[10,25,50]"
                  currentPageReportTemplate="顯示 {first} 至 {last} 項結果，共 {totalRecords} 項" responsiveLayout="scroll"> -->
            <DataTable :value="dataTableList" :paginator="true" class="p-datatable-customers" :rows="10"
                  dataKey="id" :rowHover="true" v-model:selection="selectedCustomers" paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown" :rowsPerPageOptions="[10,25,50]"
                  :currentPageReportTemplate="lang['components']['Dialog']['SelectPostDialog']['post']['datatable_page_info']" responsiveLayout="scroll">
              <Column selectionMode="multiple"></Column>
              <Column field="name" :header="lang['components']['Dialog']['SelectPostDialog']['post']['field_a']" :sortable="true" headerStyle="width: 30%">
                <template #body="slotProps">
                  <div class="text-sm" v-tooltip.top="`${slotProps.data.message}`" v-html="slotProps.data.name"></div>
                </template>
              </Column>
              <Column field="date" :header="lang['components']['Dialog']['SelectPostDialog']['post']['field_b']" :sortable="true"></Column>
              <Column field="like" :header="lang['components']['Dialog']['SelectPostDialog']['post']['field_c']" :sortable="true"></Column>
              <Column field="comment" :header="lang['components']['Dialog']['SelectPostDialog']['post']['field_d']" :sortable="true"></Column>
              <Column field="share" :header="lang['components']['Dialog']['SelectPostDialog']['post']['field_e']" :sortable="true"></Column>
              <Column field="touch" :header="lang['components']['Dialog']['SelectPostDialog']['post']['field_f']" :sortable="true"></Column>
              <Column field="interactive" :header="lang['components']['Dialog']['SelectPostDialog']['post']['field_g']" :sortable="true">
                <template #body="slotProps">
                  <div class="flex"><div class="star" v-for="n in slotProps.data.interactive" :key="n">★</div></div>
                </template>
              </Column>
              <Column field="link" :header="lang['components']['Dialog']['SelectPostDialog']['post']['field_h']" :sortable="true">
                <template #body="slotProps">
                  <div class="flex"><div class="star" v-for="n in slotProps.data.link" :key="n">★</div></div>
                </template>
              </Column>
            </DataTable>
          </div>
        </TabPanel>
        <TabPanel :header="lang['components']['Dialog']['SelectPostDialog']['TabPanel_adpost']">
          <div class="flex-wrap justify-between space-1-2 px-6">
            <Dropdown v-model="adaccountCampaignsId" :options="adaccountCampaignsList" optionLabel="name" optionValue="code" :filter="true" :placeholder="lang['components']['Dialog']['SelectPostDialog']['adpost']['adaccountCampaignsList_placeholder']" class="w-1/4 rounded-md" @change="getCampaignAdsetsData" />
            <Dropdown v-model="campaignAdsetsId" :options="campaignAdsetsList" optionLabel="name" optionValue="code" :disabled="adaccountCampaignsId == null" :filter="true" :placeholder="lang['components']['Dialog']['SelectPostDialog']['adpost']['campaignAdsetsList_placeholder']" class="w-1/4 rounded-md ml-4" @change="getAdsetAdsData" />
          </div>
          <div
            class="align-middle inline-block min-w-full shadow overflow-hidden bg-white shadow-dashboard px-6 pt-3 rounded-bl-lg rounded-br-lg">
            <!-- <DataTable :value="adsetDataTableList" :paginator="true" class="p-datatable-customers" :rows="10"
                  dataKey="id" :rowHover="true" v-model:selection="selectedAdsetCustomers" paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown" :rowsPerPageOptions="[10,25,50]"
                  currentPageReportTemplate="顯示 {first} 至 {last} 項結果，共 {totalRecords} 項" responsiveLayout="scroll"> -->
            <DataTable :value="adsetDataTableList" :paginator="true" class="p-datatable-customers" :rows="10"
                  dataKey="id" :rowHover="true" v-model:selection="selectedAdsetCustomers" paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown" :rowsPerPageOptions="[10,25,50]"
                  :currentPageReportTemplate="lang['components']['Dialog']['SelectPostDialog']['adpost']['datatable_page_info']" responsiveLayout="scroll">
              <Column selectionMode="multiple"></Column>
              <Column field="name" :header="lang['components']['Dialog']['SelectPostDialog']['adpost']['field_a']" :sortable="true" headerStyle="width: 30%">
                <template #body="slotProps">
                  <div class="text-sm" v-html="slotProps.data.name"></div>
                </template>
              </Column>
              <Column field="campaign_name" :header="lang['components']['Dialog']['SelectPostDialog']['adpost']['field_b']" :sortable="true"></Column>
              <!-- <Column field="message" header="主要內容" :sortable="true"></Column> -->
              <Column field="message" :header="lang['components']['Dialog']['SelectPostDialog']['adpost']['field_c']" :sortable="true">
                <template #body="slotProps">
                  <div class="text-sm" v-tooltip.top="`${slotProps.data.message_tooltip}`" v-html="slotProps.data.message"></div>
                </template>
              </Column>
              <!-- <Column field="touch" header="觸及人數" :sortable="true"></Column>
              <Column field="interactive" header="互動指數" :sortable="true">
                <template #body="slotProps">
                  <div class="flex"><div class="star" v-for="n in slotProps.data.interactive" :key="n">★</div></div>
                </template>
              </Column>
              <Column field="link" header="連結指數" :sortable="true">
                <template #body="slotProps">
                  <div class="flex"><div class="star" v-for="n in slotProps.data.link" :key="n">★</div></div>
                </template>
              </Column> -->
            </DataTable>
          </div>
        </TabPanel>
      </TabView>
    </div>
    <div v-if="false">
      <div v-if="postType == 'post'">
        <div class="flex flex-wrap justify-between space-1-2 px-6">
          <Dropdown v-model="type" :options="types" optionLabel="name" optionValue="code" placeholder="所有貼文類型" class="w-1/4 rounded-md" />
          <div class=" bg-white rounded-md flex items-center w-3/5 p-2 shadow-sm border border-gray-200">
            <i class="pi pi-search"></i>
            <input v-model="searchKey" type="search" class="w-full pl-4 text-sm outline-none focus:outline-none bg-transparent">
          </div>
          <button class="text-white px-4 whitespace-no-wrap rounded-xl transition duration-300 bg-blue-900 ml-4" @click="searchMaterial()">搜尋</button>
        </div>
        <div
          class="align-middle inline-block min-w-full shadow overflow-hidden bg-white shadow-dashboard px-6 pt-3 rounded-bl-lg rounded-br-lg">
          <DataTable :value="dataTableList" :paginator="true" class="p-datatable-customers" :rows="10"
                dataKey="id" :rowHover="true" v-model:selection="selectedCustomers" paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown" :rowsPerPageOptions="[10,25,50]"
                currentPageReportTemplate="顯示 {first} 至 {last} 項結果，共 {totalRecords} 項" responsiveLayout="scroll">
            <Column selectionMode="multiple"></Column>
            <Column field="name" header="活動名稱" :sortable="true" headerStyle="width: 30%">
              <template #body="slotProps">
                <div class="text-sm" v-tooltip.top="`${slotProps.data.message}`" v-html="slotProps.data.name"></div>
              </template>
            </Column>
            <Column field="date" header="建立日期" :sortable="true"></Column>
            <Column field="like" header="按讚次數" :sortable="true"></Column>
            <Column field="comment" header="留言次數" :sortable="true"></Column>
            <Column field="share" header="分享次數" :sortable="true"></Column>
            <Column field="touch" header="觸及人數" :sortable="true"></Column>
            <Column field="interactive" header="互動指數" :sortable="true">
              <template #body="slotProps">
                <div class="flex"><div class="star" v-for="n in slotProps.data.interactive" :key="n">★</div></div>
              </template>
            </Column>
            <Column field="link" header="連結指數" :sortable="true">
              <template #body="slotProps">
                <div class="flex"><div class="star" v-for="n in slotProps.data.link" :key="n">★</div></div>
              </template>
            </Column>
          </DataTable>
        </div>
      </div>
      <div v-if="postType == 'adpost'">
        <div class="flex-wrap justify-between space-1-2 px-6">
          <Dropdown v-model="adaccountCampaignsId" :options="adaccountCampaignsList" optionLabel="name" optionValue="code" :filter="true" placeholder="行銷活動列表" class="w-1/4 rounded-md" @change="getCampaignAdsetsData" />
          <Dropdown v-model="campaignAdsetsId" :options="campaignAdsetsList" optionLabel="name" optionValue="code" :disabled="adaccountCampaignsId == null" :filter="true" placeholder="廣告組合列表" class="w-1/4 rounded-md ml-4" @change="getAdsetAdsData" />
        </div>
        <div
          class="align-middle inline-block min-w-full shadow overflow-hidden bg-white shadow-dashboard px-6 pt-3 rounded-bl-lg rounded-br-lg">
          <DataTable :value="adsetDataTableList" :paginator="true" class="p-datatable-customers" :rows="10"
                dataKey="id" :rowHover="true" v-model:selection="selectedAdsetCustomers" paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown" :rowsPerPageOptions="[10,25,50]"
                currentPageReportTemplate="顯示 {first} 至 {last} 項結果，共 {totalRecords} 項" responsiveLayout="scroll">
            <Column selectionMode="multiple"></Column>
            <Column field="name" header="廣告名稱" :sortable="true" headerStyle="width: 30%">
              <template #body="slotProps">
                <div class="text-sm" v-html="slotProps.data.name"></div>
              </template>
            </Column>
            <Column field="campaign_name" header="行銷活動名稱" :sortable="true"></Column>
            <!-- <Column field="message" header="主要內容" :sortable="true"></Column> -->
            <Column field="message" header="主要內容" :sortable="true">
              <template #body="slotProps">
                <div class="text-sm" v-tooltip.top="`${slotProps.data.message_tooltip}`" v-html="slotProps.data.message"></div>
              </template>
            </Column>
            <!-- <Column field="touch" header="觸及人數" :sortable="true"></Column>
            <Column field="interactive" header="互動指數" :sortable="true">
              <template #body="slotProps">
                <div class="flex"><div class="star" v-for="n in slotProps.data.interactive" :key="n">★</div></div>
              </template>
            </Column>
            <Column field="link" header="連結指數" :sortable="true">
              <template #body="slotProps">
                <div class="flex"><div class="star" v-for="n in slotProps.data.link" :key="n">★</div></div>
              </template>
            </Column> -->
          </DataTable>
        </div>
      </div>
    </div>
    <template #footer>
      <div class="w-full justify-end py-4 border-t border-gray-400">
        <button
          class="hover:bg-gray-200 focus:outline-none rounded-xl px-4 py-1 mx-auto text-gray-400 transition duration-500 ease-in-out mt-32 border-2"
          @click="showModal=false"
        >{{lang['components']['Dialog']['SelectPostDialog']['cancel_button']}}</button>
        <!-- 新手教學 -->
        <button
          class="bg-yellow-400 hover:bg-yellow-200 focus:outline-none rounded-xl px-4 py-1 mx-auto text-blue-800 transition duration-500 ease-in-out mt-32 border-2 border-yellow-400"
          :class="{ 'ring-4 border-blue-400': guideStep === 56 }"
          style="margin-right:72px;"
          @click="selected_click()"
        >{{lang['components']['Dialog']['SelectPostDialog']['yes_button']}}</button>
      </div>
    </template>
  </Dialog>
</template>

<script>
  // import { ref } from 'vue';
  import Dialog from 'primevue/dialog';
  import Dropdown from 'primevue/dropdown';
  import DataTable from 'primevue/datatable';
  import Column from 'primevue/column';
  import Swal from 'sweetalert2/dist/sweetalert2.js'
  import 'sweetalert2/dist/sweetalert2.min.css'
  import Loading from 'vue3-loading-overlay';
  import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
  import "vue3-circle-progress/dist/circle-progress.css";
  import axios from 'axios'
  import Qs from 'qs'

  import TabView from 'primevue/tabview';
  import TabPanel from 'primevue/tabpanel';

  export default {
    name: 'SelectPostDialog',
    components: {
      Dialog,
      Dropdown,
      DataTable,
      Column,
      Loading,
      TabView,
      TabPanel
    },
    props: {
      // <!-- 新手教學 -->
      guideStep: {
        type: Number,
        default: 1
      },
      // <!-- 新手教學 -->
      show: {
        type: Boolean,
        default: false
      },
      showList: {
        type: Boolean,
        default: false
      },
      viewDatalist: {
        type: Object
      },
      selectStatus: {
        type: Boolean
      },
      itemsDatalist: {
        type: Object
      },
      prviewDatalist: {
        type: Object
      },
      pageId: {
        type: String
      },
      specialAdCategory: {
        type: String
      },
      goalsObjectiveData: {
        type: String
      },
      lang:{
        type: Object
      }
    },
    data() {
      return {
        showSelectPostDialogMyside: false,
        postType: 'post',
        postTypeList:[],
        type: 'all',
        searchKey: null,
        types: [],
        items: null,
        selectedCustomers: [],
        selectedAdsetCustomers: [],
        setPageId: null,
        dataTableList:[],
        adaccountCampaignsId: null,
        adaccountCampaignsList: null,
        campaignAdsetsId: null,
        campaignAdsetsList: null,
        adsetDataTableList: [],
        teachStatus: false,
        materialType: 0,
        dataType: '',
        // items: [{
        //     name: '新廣告活動',
        //     date: '2021/01/01',
        //     like: '100',
        //     comment: '200',
        //     share: '300',
        //     touch: '123',
        //     interactive: '5',
        //     link: '2',
        //   },
        //   {
        //     name: '新廣告活動',
        //     date: '2021/01/01',
        //     like: '100',
        //     comment: '200',
        //     share: '300',
        //     touch: '123',
        //     interactive: 4,
        //     link: 2,
        //   }
        // ]
      }
    },
    methods: {
      onTabClick(event){
        // console.log('onTabClick');
        // console.log(v);
        let index = event.index;

        this.materialType = index
      },
      posts_data_update () {
        // console.log('pageId:'+this.pageId);
        this.showSelectPostDialogMyside = false;

        if(this.materialType == 0){
          axios
            .post('https://www.autoturn.net/api/customize/campaign/campaign_form_fb_posts.php', Qs.stringify({
              s_code: this.$route.params.id,
              adaccount_id: this.$route.params.adaccount_id,
              page_id: this.pageId,
              objective: this.goalsObjectiveData,
              type: 'update'
            }))
            .then((response) => {
              if(response.data.status == 'success'){
                // console.log('posts_data');
                // console.log(response.data.return_data);
                this.dataTableList = response.data.return_data
              }

              this.showSelectPostDialogMyside = true;
            });
        } else {
          this.adaccountCampaignsId = null;
          this.campaignAdsetsId = null;
          this.campaignAdsetsList = [];
          this.adsetDataTableList = [];
          this.dataType = 'update';

          axios
            .post('https://www.autoturn.net/api/customize/campaign/campaign_form_adaccount_campaigns.php', Qs.stringify({
              s_code: this.$route.params.id,
              adaccount_id: this.$route.params.adaccount_id,
              objective: this.goalsObjectiveData,
              type: this.dataType,
            }))
            .then((response) => {
              if(response.data.status == 'success'){
              //  console.log('adset_ads_data');
              //  console.log(response.data.return_data.adaccount_campaigns_list);
                this.adaccountCampaignsList = response.data.return_data.adaccount_campaigns_list
              }

              this.showSelectPostDialogMyside = true;

            });
        }
      },
      selected_click () {
        // console.log(this.selectedCustomers);
        // console.log(this.pageIdData);
      //  console.log('this.type');
      //  console.log(this.type);
      //  console.log('this.postType');
      //  console.log(this.postType);
      //  console.log('this.selectedCustomers');
      //  console.log(this.selectedCustomers);
      //  console.log('this.selectedAdsetCustomers');
      //  console.log(this.selectedAdsetCustomers);

        let post_data_length = this.selectedCustomers.length
        let adset_data_length = this.selectedAdsetCustomers.length

      //  console.log('post_data_length:'+post_data_length);
      //  console.log('adset_data_length:'+adset_data_length);

        if(post_data_length <= 10 && adset_data_length <= 10){
        //  console.log('this.teachStatus');
        //  console.log(this.teachStatus);

          if(this.materialType == 0){
            if(this.teachStatus == true){
              if(post_data_length > 0){
                this.showSelectPostDialogMyside = false;

                axios
                  .post('https://www.autoturn.net/api/customize/campaign/campaign_form_fb_posts_mark.php', Qs.stringify({
                    s_code: this.$route.params.id,
                    adaccount_id: this.$route.params.adaccount_id,
                    page_id: this.pageIdData,
                    objective: this.goalsObjectiveData,
                    special_ad_category: this.specialAdCategoryData,
                    posts: this.selectedCustomers,
                    filter: this.type,
                    q: this.searchKey
                  }))
                  .then((response) => {
                    // console.log(response);
                    if(response.data.status == 'success'){
                      // console.log('selected_click');
                    //  console.log(response.data.return_data);
                      // console.log(response.data.return_prview);
                      // this.items = response.data.return_data
                      this.$emit('update:itemsDatalist', response.data.return_data)
                      this.$emit('update:prviewDatalist', response.data.return_prview)

                      this.showModal = false

                      this.selectedCustomers = []

                      this.$emit('childEmptyStep');

                      this.$emit('childMaterialGetData', true);
                    }

                    this.showSelectPostDialogMyside = true;
                  });
              } else {

                if(this.teachStatus == true){
                  let testTeachData = [{
                                        angry: 0,
                                        checked: false,
                                        content: "1234567890123456",
                                        cry: 0,
                                        date: "2023/01/01",
                                        great: 100,
                                        heart: 0,
                                        imgSrc: "https://test-private.autoturn.net/img/teaching.jpg",
                                        message: "（貼文編號：1234567890123456）如果你有在投廣告\n找關鍵字，找受眾，你做對了嗎？\nwww.autoturn.net",
                                        shock: 0,
                                        smile: 0,
                                        title: "教學素材...",
                                      }];
                //  console.log('testTeachData');
                //  console.log(testTeachData);

                  this.$emit('update:itemsDatalist', testTeachData)

                  this.showModal = false

                  var todayForm = new Date();
                  var yearForm = todayForm.getFullYear();
                  var dateForm = String(todayForm.getDate()).padStart(2, '0');
                  var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                  var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                  todayForm = yearForm + monthForm + dateForm + timeForm;

                //  console.log('Use existing post todayForm');
                //  console.log(todayForm);

                  this.$emit('childEmptyStep', todayForm);
                } else {
                  Swal.fire(
                            this.lang['components']['Dialog']['SelectPostDialog']['methods']['selected_click']['is_materialType_is_teachStatus_swal_title'],
                            this.lang['components']['Dialog']['SelectPostDialog']['methods']['selected_click']['is_materialType_is_teachStatus_swal_text'],
                            "warning"
                          )
                }
              }
            } else {
              this.showSelectPostDialogMyside = false;

              axios
                .post('https://www.autoturn.net/api/customize/campaign/campaign_form_fb_posts_mark.php', Qs.stringify({
                  s_code: this.$route.params.id,
                  adaccount_id: this.$route.params.adaccount_id,
                  page_id: this.pageIdData,
                  objective: this.goalsObjectiveData,
                  special_ad_category: this.specialAdCategoryData,
                  posts: this.selectedCustomers,
                  filter: this.type,
                  q: this.searchKey
                }))
                .then((response) => {
                  // console.log(response);
                  if(response.data.status == 'success'){
                    // console.log('selected_click');
                    // console.log(response.data.return_data);
                    // console.log(response.data.return_prview);
                    // this.items = response.data.return_data
                    this.$emit('update:itemsDatalist', response.data.return_data)
                    this.$emit('update:prviewDatalist', response.data.return_prview)

                    this.showModal = false

                    this.selectedCustomers = []

                    this.$emit('childEmptyStep');

                    this.$emit('childMaterialGetData', true);
                  }

                  this.showSelectPostDialogMyside = true;
                });
            }
          } else {
            //走廣告的存取方式
            if(adset_data_length > 0){
              this.showSelectPostDialogMyside = false;

              axios
                .post('https://www.autoturn.net/api/customize/campaign/campaign_form_adset_ads_mark.php', Qs.stringify({
                  s_code: this.$route.params.id,
                  adset_id: this.campaignAdsetsId,
                  page_id: this.pageId,
                  form_data: this.selectedAdsetCustomers
                }))
                .then((response) => {
                  // console.log(response);
                  if(response.data.status == 'success'){
                  //  console.log('selected_click');
                  //  console.log(response.data.return_data);
                  //  console.log(response.data.return_prview);
                    // this.items = response.data.return_data
                  //  console.log(this.goalsObjectiveData);

                    if(this.goalsObjectiveData == 'MESSAGES'){
                      this.$emit('update:adsetAdsMessageDatalist', response.data.return_data)
                      this.$emit('update:prviewAdsetAdsMessageDatalist', response.data.return_prview)
                    } else {
                      this.$emit('update:adsetAdsDatalist', response.data.return_data)
                      this.$emit('update:prviewAdsetAdsDatalist', response.data.return_prview)
                    }

                    this.showModal = false

                    this.selectedAdsetCustomers = []

                    this.$emit('childMaterialGetData', true);
                  }

                  this.showSelectPostDialogMyside = true;
                });
            } else {
              Swal.fire(
                        this.lang['components']['Dialog']['SelectPostDialog']['methods']['selected_click']['not_materialType_swal_title'],
                        this.lang['components']['Dialog']['SelectPostDialog']['methods']['selected_click']['not_materialType_swal_text'],
                        "warning"
                      )
            }
          }
        } else {
          Swal.fire(
                      this.lang['components']['Dialog']['SelectPostDialog']['methods']['selected_click']['have_not_length_swal_title'],
                      this.lang['components']['Dialog']['SelectPostDialog']['methods']['selected_click']['have_not_length_swal_text'],
                      "warning"
                    )
        }
      },
      searchMaterial(){
        // console.log('this.type');
        // console.log(this.type);
        // console.log('this.searchKey');
        // console.log(this.searchKey);
        // console.log('this.viewDatalistData');
        // console.log(this.viewDatalistData);
        // console.log('this.specialAdCategoryData');
        // console.log(this.specialAdCategoryData);

        this.showSelectPostDialogMyside = false;
        if((this.type != '' && this.type != null && typeof this.type != 'undefined') || (this.searchKey != '' && this.searchKey != null && typeof this.searchKey != 'undefined')){
          axios
            .post('https://www.autoturn.net/api/customize/campaign/campaign_form_fb_posts.php', Qs.stringify({
              s_code: this.$route.params.id,
              adaccount_id: this.$route.params.adaccount_id,
              page_id: this.pageIdData,
              objective: this.goalsObjectiveData,
              special_ad_category: this.specialAdCategoryData,
              filter: this.type,
              q: this.searchKey
            }))
            .then((response) => {
              // console.log(response);
              if(response.data.status == 'success'){
                // console.log('b this.viewDatalistData');
                // console.log(this.viewDatalistData);
                // console.log('response.data.return_data');
                // console.log(response.data.return_data);
                this.dataTableList = response.data.return_data
                // console.log('a this.viewDatalistData');
                // console.log(this.viewDatalistData);
              }

              this.showSelectPostDialogMyside = true;
            });
        }
      },
      getCampaignAdsetsData(){
      //  console.log('getCampaignAdsetsData');
      //  console.log(this.adaccountCampaignsId);

        let adaccountCampaignsId = this.adaccountCampaignsId
        if(adaccountCampaignsId != '' && adaccountCampaignsId != null && typeof adaccountCampaignsId != 'undefined'){
          this.showSelectPostDialogMyside = false;

          axios
            .post('https://www.autoturn.net/api/customize/campaign/campaign_form_campaign_adsets.php', Qs.stringify({
              s_code: this.$route.params.id,
              campaign_id: adaccountCampaignsId,
              type: this.dataType,
            }))
            .then((response) => {
              // console.log(response);
              if(response.data.status == 'success'){
                // console.log('selected_click');
              //  console.log(response.data.return_data.campaign_adsets_list);
                // console.log(response.data.return_prview);
                // this.items = response.data.return_data

                // this.dataTableList = [];
                this.campaignAdsetsList = response.data.return_data.campaign_adsets_list
              }

              this.showSelectPostDialogMyside = true;
              this.campaignAdsetsId = null;
              this.adsetDataTableList = [];
            });
        }
      },
      getAdsetAdsData(){
      //  console.log('getAdsetAdsData');
      //  console.log(this.campaignAdsetsId);

        let campaignAdsetsId = this.campaignAdsetsId
        if(campaignAdsetsId != '' && campaignAdsetsId != null && typeof campaignAdsetsId != 'undefined'){
          this.showSelectPostDialogMyside = false;
          this.adsetDataTableList = [];

          axios
          .post('https://www.autoturn.net/api/customize/campaign/campaign_form_adset_ads.php', Qs.stringify({
            s_code: this.$route.params.id,
            adset_id: campaignAdsetsId,
            page_id: this.pageId,
            type: this.dataType,
          }))
          .then((response) => {
            if(response.data.status == 'success'){
              // console.log('posts_data');
              // console.log(response.data.return_data);
              this.adsetDataTableList = response.data.return_data
            }

            this.dataType = '';
            this.showSelectPostDialogMyside = true;
          });
        }
      }
    },
    // setup(props) {
    // //  console.log("Setup props:", props);

    //   watch((first, second) => {
    //   //  console.log("Watch function called with args:", first, second);
    //   });

    //   watch(props.selected, (first, second) => {
    //   //  console.log(
    //       "Watch props.selected function called with args:",
    //       first,
    //       second
    //     );
    //   });

    //   return {props};
    // },
    // setup() {
    //     const selectedCustomers = ref();
    //     return { selectedCustomers }
    // },
    watch: {
      selectStatus(val){
      //  console.log('Use existing post dialog selectStatus');
      //  console.log(val);
      //  console.log(this.showModal);

        if(val == true){
          this.teachStatus = true;
          if(this.showModal != false){
            this.selected_click();
          }
        }
      },
      'postType': function(v){
      //  console.log('postType');
      //  console.log(v);

        if(v == 'post'){
          this.showSelectPostDialogMyside = false;
        //  console.log()
          if((this.type != '' && this.type != null && typeof this.type != 'undefined') || (this.searchKey != '' && this.searchKey != null && typeof this.searchKey != 'undefined')){
            axios
              .post('https://www.autoturn.net/api/customize/campaign/campaign_form_fb_posts.php', Qs.stringify({
                s_code: this.$route.params.id,
                adaccount_id: this.$route.params.adaccount_id,
                page_id: this.pageIdData,
                objective: this.goalsObjectiveData,
                special_ad_category: this.specialAdCategoryData,
                filter: this.type,
                q: this.searchKey
              }))
              .then((response) => {
                // console.log(response);
                if(response.data.status == 'success'){
                  // console.log('b this.viewDatalistData');
                  // console.log(this.viewDatalistData);
                  // console.log('response.data.return_data');
                  // console.log(response.data.return_data);
                  this.dataTableList = response.data.return_data
                  // console.log('a this.viewDatalistData');
                  // console.log(this.viewDatalistData);
                }

                this.showSelectPostDialogMyside = true;
              });
          }
        } else {
          // this.adaccountCampaignsId = null;
          // this.adaccountCampaignsList = null;
          // this.campaignAdsetsId = null;
          // this.campaignAdsetsList = null;
          // this.adsetDataTableList = [];
          this.showSelectPostDialogMyside = false;

          axios
            .post('https://www.autoturn.net/api/customize/campaign/campaign_form_adaccount_campaigns.php', Qs.stringify({
              s_code: this.$route.params.id,
              adaccount_id: this.$route.params.adaccount_id,
              objective: this.goalsObjectiveData,
            }))
            .then((response) => {
              if(response.data.status == 'success'){
              //  console.log('adset_ads_data');
              //  console.log(response.data.return_data.adaccount_campaigns_list);
                this.adaccountCampaignsList = response.data.return_data.adaccount_campaigns_list
              }

              this.showSelectPostDialogMyside = true;
            });
        }
      },
      'pageIdData': function(v){
        // console.log('selectpostdialog pageIdData:'+v);
      },
      'viewDatalist': function(v){
      //  console.log('selectpostdialog viewDatalist:'+v);
        this.dataTableList = v;
        this.searchKey = null;

        // this.adaccountCampaignsId = null;
        // this.adaccountCampaignsList = null;
        // this.campaignAdsetsId = null;
        // this.campaignAdsetsList = null;
        // this.adsetDataTableList = [];
        // this.showSelectPostDialogMyside = false;

        axios
          .post('https://www.autoturn.net/api/customize/campaign/campaign_form_adaccount_campaigns.php', Qs.stringify({
            s_code: this.$route.params.id,
            adaccount_id: this.$route.params.adaccount_id,
            objective: this.goalsObjectiveData,
          }))
          .then((response) => {
            if(response.data.status == 'success'){
            //  console.log('adset_ads_data');
            //  console.log(response.data.return_data.adaccount_campaigns_list);
              this.adaccountCampaignsList = response.data.return_data.adaccount_campaigns_list
            }

            // this.showSelectPostDialogMyside = true;
          });

        if(v != '' && v != null && typeof v != 'undefined'){
          if(v.length > 0){
            this.showSelectPostDialogMyside = true;
          }
        }
      },
      'showModal': function(v){
      //  console.log('showModal');
      //  console.log(v);
        if(v == true){
          this.type = 'all';
          this.materialType = 0;

          this.adaccountCampaignsId = null;
          this.campaignAdsetsId = null;
          this.campaignAdsetsList = [];
          this.adsetDataTableList = [];
          this.dataType = '';

          this.postTypeList = [
            {
              name: this.lang['components']['Dialog']['SelectPostDialog']['post']['postTypeList']['post'],
              code: 'post'
            },
            {
              name: this.lang['components']['Dialog']['SelectPostDialog']['post']['postTypeList']['adpost'],
              code: 'adpost'
            }
          ];

          this.types = [
            {
              name: this.lang['components']['Dialog']['SelectPostDialog']['post']['types']['all'],
              code: 'all'
            },
            {
              name: this.lang['components']['Dialog']['SelectPostDialog']['post']['types']['published'],
              code: 'published'
            },
            {
              name: this.lang['components']['Dialog']['SelectPostDialog']['post']['types']['ads'],
              code: 'ads'
            },
            {
              name: this.lang['components']['Dialog']['SelectPostDialog']['post']['types']['scheduled'],
              code: 'scheduled'
            },
          ];

          axios
            .post('https://www.autoturn.net/api/customize/campaign/campaign_form_adaccount_campaigns.php', Qs.stringify({
              s_code: this.$route.params.id,
              adaccount_id: this.$route.params.adaccount_id,
              objective: this.goalsObjectiveData,
              type: this.dataType,
            }))
            .then((response) => {
              if(response.data.status == 'success'){
              //  console.log('adset_ads_data');
              //  console.log(response.data.return_data.adaccount_campaigns_list);
                this.adaccountCampaignsList = response.data.return_data.adaccount_campaigns_list
              }

              this.showSelectPostDialogMyside = true;

            });
        }
      },
      'showList': function(v){

        this.showSelectPostDialogMyside = v;
      },
      'guideStep': function(v){
      //  console.log('Use existing post guideStep');
      //  console.log(v);

        if(v != 1){
          this.teachStatus = true
        } else {
          this.teachStatus = false
        }
      }
    },
    computed: {
      showModal: {
        get: function () {
          return this.show
        },
        set: function (value) {
          this.$emit('update:show', value)
        }
      },
      viewDatalistData: {
        get: function () {
          return this.viewDatalist
        },
        set: function (value) {
          this.$emit('update:viewDatalistData', value)
        },
      },
      pageIdData: {
        get: function () {
          return this.pageId
        },
        set: function (value) {
          this.$emit('update:pageIdData', value)
        },
      },
      specialAdCategoryData: {
        get: function () {
          return this.specialAdCategory
        },
        set: function (value) {
          this.$emit('update:specialAdCategoryData', value)
        },
      }
    }
  }
</script>

<style lang="scss" scope>
  .star {
    &:nth-child(1) {
      color: #FADB76;
    }
    &:nth-child(2) {
      color: #2FCABD;
    }
    &:nth-child(3) {
      color: #72B6F4;
    }
    &:nth-child(4) {
      color: #6298D7;
    }
    &:nth-child(5) {
      color: #1D619F;
    }
  }
</style>